/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { HiDocumentAdd } from "react-icons/hi";
import { Link, useNavigate } from "react-router-dom";
import GlobalForm from "../../../components/globalForm/GlobalForm";
import Loading from "../../../components/shared/loading/Loading";
import { updateData } from "../../../hooks/update";
import useFetch from "../../../hooks/useFetch";
import { apiPath, clientSideUrl, RoutePath } from "../../../utility/Constant";

const BoardCreate = () => {
  const { boardApi } = apiPath;
  const { aboutUsBoardList } = RoutePath;
  const navigate = useNavigate();

  const data = [
    {
      elementType: "input",
      label: "Name",
      type: "Text",
      name: "Name",
      required: false,
    },
    {
      elementType: "input",
      label: "Position",
      type: "Text",
      name: "Position",
      required: false,
    },
    {
      elementType: "input",
      label: "Gender",
      type: "Text",
      name: "Gender",
      required: false,
    },
    {
      elementType: "textField",
      label: "description",
      type: "Text",
      name: "description",
      required: false,
    },
    {
      elementType: "file",
      label: `Image`,
      name: "image",
      type: "file",
      fullCol: true,
      required: false,
    },
  ];

  const update = async (data) => {
    const { image, ...rest } = data;
    if (image) {
      rest.image = {
        url: image,
      };
    }
    const res = await updateData(boardApi, rest, null, true);
    if (res?.length > 0) {
      setTimeout(() => {
        window.location.href = "/" + aboutUsBoardList;
      }, 600);
    }
  };

  return (
    <div>
      <div className="md:pl-14 mt-4">
        <h1 className="font-bold text-xl md:text-2xl md:-mb-10 uppercase">
          <HiDocumentAdd className="inline w-7 h-7 mb-1" /> Add new BOARD MEMBER
        </h1>
      </div>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default BoardCreate;
